// extracted by mini-css-extract-plugin
module.exports = {"container":"algoliaPagination_container__7VOju","pages":"algoliaPagination_pages__vlLgg"};